import { useReportCtx } from '@app/core/reports/report-ctx';
import { auditReports } from '@mi-front/api-clients';
import { MRT_RowSelectionState } from 'material-react-table';
import { useEffect, useState } from 'react';
import { GipAlternativeReportType } from '../../types';

export function useIncludeMatches(matches: auditReports.GipAltReportMatchDto[]) {
  const { values, setValues } = useReportCtx<GipAlternativeReportType>();

  const [includeAll, setIncludeAll] = useState(true);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  function toggleIncludeAll(newIncludeAll: boolean) {
    if (newIncludeAll) {
      setRowSelection({});
    } else {
      setRowSelection(
        matches
          .map((m) => m.id)
          .reduce((all, key) => {
            all[key] = true;
            return all;
          }, {} as MRT_RowSelectionState),
      );
    }

    setValues({
      ...values,
      excludedMatches: [],
    });

    setIncludeAll(newIncludeAll);
  }

  useEffect(() => {
    const selected = Object.keys(rowSelection);

    if (!selected.length || selected.length === matches.length) {
      setValues({
        ...values,
        excludedMatches: [],
      });
    } else {
      setValues({
        ...values,
        excludedMatches: matches.map((m) => m.id).filter((id) => !selected.includes(id)),
      });
    }
  }, [rowSelection]);

  return {
    includeAll,
    toggleIncludeAll,
    setRowSelection,
    rowSelection,
  };
}
